import { createUseStyles } from 'react-jss'
import { BUTTON_WIDTH } from 'src/config/styles'
import customColors from 'src/config/colorsV2'
import { forTabletPortraitUp } from 'src/config/mediaQueries'

export default createUseStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: customColors.background,
    padding: [12, 16],
  },
  buttonCont: {
    width: '100%',
    [forTabletPortraitUp]: {
      width: BUTTON_WIDTH,
    },
  },
})
